import OrderModel from './OrderModel';

export default OrderModel;
